module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Pictures2-b7063279680ccd1a24eb69c0d3c53519.svg";